import { CampaignDataFragment, CampaignFragment } from "@server/gql/graphql";
import z from "zod";

const ruleValueSchema = z.object({
  id: z.number(),
  code: z.string(),
  name: z.string(),
});

const ruleSchema = z.object({
  id: z.string(),
  dimension: z.enum(["brand", "category", "designer", "flag", "series"]),
  operator: z.enum(["include", "exclude"]),
  values: z.array(ruleValueSchema),
});

const rulesSchema = z.array(ruleSchema);

export default function validateCampaignRules(
  rules: CampaignDataFragment["rules"],
) {
  return rulesSchema.safeParse(rules);
}

export function hasCampaignRules(rules: CampaignFragment["rules"]) {
  const parsed = validateCampaignRules(rules);
  return parsed.success && parsed.data.length > 0;
}
